import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Courses } from "../Courses";
import CourseBanner from "../CourseBanner";
import ExploreProgram from "../../Program/ExploreProgram";
import Reviews from "../../Program/Reviews/Reviews";
import Faq from "../../Faq/Faq";
import ProgrameAdvisor from "../../Become On Instructor/ProgramAdvisor";
import { useLocation } from "react-router-dom";

const CoursesContainer = ({
  isFetching,
  currentPage,
  totalPage,
  total,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const courses = useSelector((state) => state?.course?.myCourses?.all?.courses || []);
  const { state } = location || {};
  const { filterCourse, subCourses } = state || {};

  const [filter, setFilter] = useState({
    filterCategory: null,
    filterSubCategory: null,
    filterLevel: "All",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value === "All Courses" ? null : value,
      ...(name === "filterCategory" && {
        filterSubCategory: null,
        filterLevel: "All",
      }),
    }));
  };

  return (
    <>
      <CourseBanner />
      <ProgrameAdvisor />
      <ExploreProgram />
      <Reviews />
      <Faq />
      {/* Uncomment below to show courses and pagination */}
      {/* <Courses
        courses={courses}
        varient="courses"
        title="All Courses"
        total={total}
        isFetching={isFetching}
        handlefilterChange={handleFilterChange}
        Filter={filter}
        setFilter={setFilter}
      /> */}
    </>
  );
};

const mapStateToProps = (state) => {
  const { all: allCourses, isFetching } = state.course.myCourses;
  return {
    isFetching: isFetching,
    currentPage: allCourses?.currentPage || 1,
    totalPage: allCourses?.totalPage || 1,
    total: allCourses?.total || 0,
  };
};

export default connect(mapStateToProps)(CoursesContainer);